/* FERAL site health v1. Source: feral-events/browser/site-health.js (mirrored here).
 * One beacon per page view to events.feralclo.com/api/site, read by `feral-site` on the estate.
 * Measures how the page felt (LCP, INP, CLS, FCP, TTFB), what broke (script errors, a refused
 * add to bag) and where shoppers struggled (rage taps, sold-out sizes, empty searches, 404s).
 * Collected in memory only: no cookie, no storage, no visitor id. Sent only after the visitor
 * accepted analytics in the cookie banner (the same rule as feral-owned-tracking.js). */
(function () {
  'use strict';
  if (window.__feralSiteHealth) return;
  window.__feralSiteHealth = 1;
  var cfg = window.__feralSite || {};
  var endpoint = 'https://events.feralclo.com/api/site';
  var t0 = Date.now(), clarityOn = false;
  var ev = [], sentVitals = false, errs = 0, seenErr = {};
  var preview = !!(window.Shopify && (Shopify.designMode || (Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main')));

  function now() { return Math.round(performance.now()); }
  function push(e) {
    if (ev.length < 60) { e.at = now(); ev.push(e); }
    try { if (window.clarity && clarityOn) { clarity('event', e.t); if (e.t === 'cart_fail' || e.t === 'js_error' || e.t === 'rage_click') clarity('upgrade', e.t); } } catch (x) {}
  }
  function read(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function allowed() {
    var c = read('feral_cookie_consent_v1');
    if (!(c && c.decided && !c.implicit && c.analytics)) return false;
    try { var s = Shopify.customerPrivacy.currentVisitorConsent(); if (s && s.analytics === 'no') return false; } catch (e) {}
    return true;
  }
  function describe(el) {
    if (!el || !el.tagName) return null;
    var s = el.tagName.toLowerCase();
    if (el.id) s += '#' + el.id;
    var cls = (typeof el.className === 'string' ? el.className : '').trim().split(/\s+/).filter(Boolean).slice(0, 2);
    if (cls.length) s += '.' + cls.join('.');
    var data = el.getAttributeNames ? el.getAttributeNames().filter(function (a) { return a.indexOf('data-') === 0; })[0] : null;
    if (data) s += '[' + data + ']';
    var txt = (el.innerText || el.value || el.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim().slice(0, 30);
    return txt ? s + ' "' + txt + '"' : s;
  }
  function refClass() {
    try {
      if (!document.referrer) return 'none';
      var h = new URL(document.referrer).hostname.replace(/^www\./, '');
      if (/feralclo\.com$|myshopify\.com$|shopify\.com$/.test(h)) return 'internal';
      if (/instagram/.test(h)) return 'instagram';
      if (/facebook|fb\.|messenger/.test(h)) return 'facebook';
      if (/tiktok/.test(h)) return 'tiktok';
      if (/google\./.test(h)) return 'google';
      if (/bing|duckduckgo|yahoo|ecosia/.test(h)) return 'search_other';
      if (/chatgpt|openai|perplexity|claude|gemini/.test(h)) return 'ai';
      return h.slice(0, 40);
    } catch (e) { return 'other'; }
  }
  function page() {
    var w = window.innerWidth || 0, q = new URLSearchParams(location.search), nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var conn = navigator.connection || {};
    return {
      path: location.pathname, template: cfg.template || null, handle: cfg.handle || null,
      country: cfg.country || null, market: cfg.market || null, locale: cfg.locale || null,
      device: w < 768 ? 'mobile' : w < 1024 ? 'tablet' : 'desktop', vw: w,
      net: conn.effectiveType || null, ref: refClass(), nav: nav ? nav.type : null,
      utm_source: q.get('utm_source'), utm_campaign: q.get('utm_campaign'),
      first: !document.referrer || refClass() !== 'internal', test: preview || q.has('site_health_test')
    };
  }

  // ── Vitals (the same definitions Chrome's web-vitals library uses) ──
  var lcp = null, lcpEl = null, cls = 0, clsWin = 0, clsFirst = 0, clsLast = 0, inter = {}, fcp = null;
  function observe(type, fn, opts) {
    try { var o = new PerformanceObserver(function (l) { l.getEntries().forEach(fn); }); o.observe(Object.assign({ type: type, buffered: true }, opts || {})); return o; } catch (e) { return null; }
  }
  var lcpObs = observe('largest-contentful-paint', function (e) { lcp = e.startTime; lcpEl = describe(e.element); });
  observe('layout-shift', function (e) {
    if (e.hadRecentInput) return;
    if (clsWin && e.startTime - clsLast < 1000 && e.startTime - clsFirst < 5000) clsWin += e.value;
    else { clsWin = e.value; clsFirst = e.startTime; }
    clsLast = e.startTime; if (clsWin > cls) cls = clsWin;
  });
  observe('paint', function (e) { if (e.name === 'first-contentful-paint') fcp = e.startTime; });
  observe('event', function (e) {
    if (!e.interactionId) return;
    var cur = inter[e.interactionId];
    if (!cur || e.duration > cur.d) inter[e.interactionId] = { d: e.duration, el: e.target };
  }, { durationThreshold: 40 });
  ['keydown', 'click', 'pointerdown'].forEach(function (t) { addEventListener(t, function () { if (lcpObs) { lcpObs.takeRecords && lcpObs.takeRecords(); lcpObs.disconnect(); lcpObs = null; } }, { once: true, capture: true }); });
  function vitals() {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var list = Object.keys(inter).map(function (k) { return inter[k]; }).sort(function (a, b) { return b.d - a.d; });
    var worst = list.length ? list[Math.min(list.length - 1, Math.floor(list.length / 50))] : null;
    return {
      t: 'vitals', lcp: lcp, cls: Math.round(cls * 1000) / 1000, fcp: fcp,
      ttfb: nav ? Math.max(0, nav.responseStart - (nav.activationStart || 0)) : null,
      inp: worst ? worst.d : null, count: list.length, lcp_el: lcpEl, inp_el: worst ? describe(worst.el) : null
    };
  }

  // ── What broke ──
  function onErr(msg, src, line) {
    msg = String(msg || 'error').slice(0, 200);
    if (/^Script error\.?$/.test(msg) && !src) return;
    var key = msg + '|' + src + '|' + line;
    if (seenErr[key] || errs >= 8) return;
    seenErr[key] = 1; errs++;
    push({ t: 'js_error', msg: msg, src: src ? String(src).split('/').pop().split('?')[0] : null, line: line || null });
  }
  (window.__feralErr || []).forEach(function (a) { onErr(a[0], a[1], a[2]); });
  window.__feralErr = { push: function (a) { onErr(a[0], a[1], a[2]); } };
  addEventListener('error', function (e) {
    if (e.target && e.target !== window && e.target.tagName) {
      var u = e.target.src || e.target.href || '';
      if (/\/cdn\/shop\/|cdn\.shopify\.com/.test(u)) push({ t: 'js_error', kind: 'asset', msg: 'failed to load ' + e.target.tagName.toLowerCase(), src: String(u).split('/').pop().split('?')[0] });
      return;
    }
    onErr(e.message, e.filename, e.lineno);
  }, true);
  addEventListener('unhandledrejection', function (e) { var r = e.reason; onErr('unhandled: ' + (r && (r.message || r.description) || String(r)), r && r.fileName, null); });

  var origFetch = window.fetch;
  if (origFetch) window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update)(\.js)?/.test(url)) {
      p.then(function (r) {
        if (!r.ok) r.clone().json().then(function (j) { push({ t: 'cart_fail', status: r.status, url: url.replace(/^.*\/cart\//, 'cart/'), msg: j && (j.description || j.message) }); }).catch(function () { push({ t: 'cart_fail', status: r.status, url: url.replace(/^.*\/cart\//, 'cart/') }); });
      }, function (err) { push({ t: 'cart_fail', status: 0, url: url.replace(/^.*\/cart\//, 'cart/'), msg: String(err && err.message || err) }); });
    }
    return p;
  };

  // ── Where shoppers struggled ──
  var clicks = [];
  addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target : null;
    if (!el) return;
    var t = Date.now(), real = e.isTrusted && (e.clientX || e.clientY) && e.detail;
    clicks = clicks.filter(function (c) { return t - c.t < 800; });
    if (real) clicks.push({ t: t, x: e.clientX, y: e.clientY });
    var near = clicks.filter(function (c) { return Math.abs(c.x - e.clientX) < 30 && Math.abs(c.y - e.clientY) < 30; });
    if (real && near.length === 3) push({ t: 'rage_click', el: describe(el.closest('a,button,label,input,[role=button]') || el) });

    var pill = el.tagName === 'INPUT' && el.closest('.fp__pill');   // a tap on the label arrives again on its input
    if (pill) {
      var v = (pill.querySelector('input') || {}).value;
      push({ t: pill.classList.contains('is-unavailable') ? 'size_soldout' : 'size_pick', value: v });
    }
    var row = el.closest('[data-fp-sheet-row]');
    if (row) push({ t: row.getAttribute('data-fp-sheet-row-oos') === 'true' ? 'size_soldout' : 'size_pick', value: (row.innerText || '').trim().split(/\s+/)[0] });
    var cta = el.closest('[data-fp-cta]');
    if (cta) push({ t: document.querySelector('[data-fp-pill]:checked') ? 'atc_click' : 'atc_no_size', kind: cta.classList.contains('is-sold-out') ? 'notify' : 'add' });
    if (el.closest('[data-fp-size-guide]')) push({ t: 'size_guide' });
    if (el.closest('[name="checkout"],a[href*="/checkout"],button[form="cart"][type="submit"]')) push({ t: 'checkout_click' });
  }, true);

  var swipes = 0, swipeTimer = null, gal = document.querySelector('[data-fp-gallery]');
  if (gal) gal.addEventListener('scroll', function () {
    if (!swipeTimer) swipes++;
    clearTimeout(swipeTimer); swipeTimer = setTimeout(function () { swipeTimer = null; }, 300);
  }, { passive: true, capture: true });

  if (cfg.template === 'search' && cfg.terms) push({ t: cfg.results === 0 ? 'search_none' : 'search', q: cfg.terms, n: cfg.results });
  if (cfg.template === '404') push({ t: 'not_found', url: location.pathname });

  var maxDepth = 0, visibleMs = 0, visibleFrom = document.visibilityState === 'visible' ? Date.now() : null;
  addEventListener('scroll', function () {
    var h = document.documentElement.scrollHeight - innerHeight;
    if (h > 0) maxDepth = Math.max(maxDepth, Math.min(100, Math.round(scrollY / h * 100)));
  }, { passive: true });

  function flush() {
    if (visibleFrom) { visibleMs += Date.now() - visibleFrom; visibleFrom = null; }
    if (!allowed()) { ev = []; return; }
    var out = ev; ev = [];
    if (!sentVitals) {
      sentVitals = true;
      out.unshift(vitals());
      out.push({ t: 'engage', ms: visibleMs, depth: maxDepth, n: swipes ? Math.min(swipes, 999) : 0 });
    }
    if (!out.length) return;
    var body = JSON.stringify({ page: page(), ev: out });
    try {
      if (!(navigator.sendBeacon && navigator.sendBeacon(endpoint, new Blob([body], { type: 'text/plain' }))))
        fetch(endpoint, { method: 'POST', body: body, keepalive: true, headers: { 'content-type': 'text/plain' } });
    } catch (e) {}
  }
  addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush();
    else visibleFrom = Date.now();
  });
  addEventListener('pagehide', flush);
  window.__feralSiteHealthFlush = flush;

  // ── Microsoft Clarity: session replays and heatmaps, only after analytics was accepted ──
  // Masking is Balanced (typed text and form fields never recorded). The tags below let a replay be
  // found by what went wrong: filter Clarity on the custom event "cart_fail", "size_soldout"...
  function clarityLoad() {
    if (clarityOn || !cfg.clarity || preview || !allowed()) return;
    clarityOn = true;
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', cfg.clarity);
    clarity('consentv2', { ad_Storage: 'denied', analytics_Storage: 'granted' });
    var p = page();
    ['template', 'country', 'market', 'device', 'ref'].forEach(function (k) { if (p[k]) clarity('set', k, String(p[k])); });
    if (cfg.handle) clarity('set', 'handle', cfg.handle);
    ev.forEach(function (e) { clarity('event', e.t); });
  }
  clarityLoad();
  addEventListener('feral:consent', function () { setTimeout(clarityLoad, 0); });
})();
